import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import Select from 'react-select';
import { Actions as COURSEACTIONS } from "../../../store/actions/courseActions";
import { PencilIcon } from "@heroicons/react/20/solid";

const AttendeeRow = ({
    attendee,
    changeWebinarAttendeeName,
    changeWebinarAttendeeEmail,
    setWebinarAttendeeCertificateStatus,
    position,
}) => {
    const [nameEditMode, setNameEditMode] = useState(false);
    const [emailEditMode, setEmailEditMode] = useState(false);
    const [attendeeFirstName, setAttendeeFirstName] = useState(attendee?.["First Name"]);
    const [attendeeLastName, setAttendeeLastName] = useState(attendee?.["Last Name"]);
    const [attendeeEmail, setAttendeeEmail] = useState(attendee?.Email);

    return (
        <tr>
            <td style={{textAlign: 'center'}}>
                    {!nameEditMode ? <p style={{margin: 0}}>{attendeeFirstName + " " + attendeeLastName}</p>
                    : <>
                            <input
                            type="text"
                            value={attendeeFirstName}
                            style={{margin: "auto"}}
                            onChange={(e) => setAttendeeFirstName(e.target.value)}/>
                            <input
                            type="text"
                            value={attendeeLastName}
                            style={{margin: "auto"}}
                            onChange={(e) => setAttendeeLastName(e.target.value)}
                            />
                        </>}
                    <PencilIcon className="w-6 h-6 mr-3 pull-right"
                    onClick={() => {
                        if (nameEditMode){
                            changeWebinarAttendeeName(position, attendeeFirstName, attendeeLastName)
                        }
                        setNameEditMode(!nameEditMode)
                    }}
                    style={{ cursor: "pointer"  }}/>
            </td>
            <td style={{textAlign: 'center'}}>
                    <div>
                        {!emailEditMode ? <p style={{margin: 0}}>{attendeeEmail}</p>
                        :
                        <>
                            <input
                            type="email"
                            value={attendeeEmail}
                            style={{margin: "auto"}}
                            onChange={(e) => setAttendeeEmail(e.target.value)}/>
                        </>
                        }
                        <PencilIcon className="w-6 h-6 mr-3 pull-right"
                            onClick={() => {
                                if (emailEditMode){
                                    changeWebinarAttendeeEmail(position, attendeeEmail)
                                }
                                setEmailEditMode(!emailEditMode)}
                            }
                            style={{ cursor: "pointer" }}
                        />
                    </div>
            </td>
            <td>
            <label className="css-input switch switch-sm switch-success">
                <input
                    type="checkbox"
                    className="checkbox-toggle"
                    checked={attendee?.["Certificate Status"]}
                    onChange={(e) => {setWebinarAttendeeCertificateStatus(position, e.target.checked)}}
                />
                <span />
              </label>
            </td>
        </tr>
    )
}

const mapStateToProps = (state, ownProps) => {
    return {
        attendee: state.courseWebinarAttendanceImport.data[ownProps.position],
    }
}

const mapDispatchToProps = dispatch => ({
    changeWebinarAttendeeName: (index, attendeeName, attendeeSurname) => dispatch(COURSEACTIONS.changeWebinarAttendeeName(index, attendeeName, attendeeSurname)),
    changeWebinarAttendeeEmail: (index, attendeeEmail) => dispatch(COURSEACTIONS.changeWebinarAttendeeEmail(index, attendeeEmail)),
    setWebinarAttendeeCertificateStatus: (index, status) => dispatch(COURSEACTIONS.setWebinarAttendeeCertificateStatus(index, status)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AttendeeRow)
